<script>
export default {
    name: 'SiteBackground',
    computed: {
        routeName() {
            const routeSplits = this.$route.path.split('/');
            return routeSplits[1];
        },
        navigationDepth() {
            return this.$route.path.split('/').length;
        }
    }
};
</script>

<template>
    <div class="site-background" v-bind:class="['site-background--' + routeName, 'site-background--depth-' + navigationDepth]">
        <transition name="fade" mode="out-in">
            <div class="site-background__image site-background__image--home" v-if="routeName === 'home'" key="home"></div>
            <div class="site-background__image site-background__image--fragen" v-if="routeName === 'fragen-antworten'" key="fragen"></div>
            <div class="site-background__image site-background__image--schizophrenie" v-if="routeName === 'schizophrenie'" key="schizophrenie"></div>
            <div class="site-background__image site-background__image--hilfsangebote" v-if="routeName === 'hilfsangebote'" key="hilfsangebote"></div>
        </transition>
    </div>
</template>

<style lang="scss" scoped>
.site-background {
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    overflow: hidden;
    z-index: -1;
}
.site-background__image {
    width: 100%; height: 100%;
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% auto;
}

.site-background--home {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    opacity: .66;
}
.site-background--home.site-background--depth-3 {
    height: 121vh;
}
.site-background__image--home {    
    height: 121vh;
    background-size: cover;
    background-position-y: bottom;
    background-image: url(~@/assets/images/cloud-background.jpg);
}
.site-background__image--fragen {
    background-image: url(~@/assets/images/background-fragen.jpg);

    @include breakpoint('xs-down') {
        background-image: url(~@/assets/images/background-fragen-mobile.jpg);
    }
}
.site-background__image--schizophrenie {
    background-image: url(~@/assets/images/background-schizophrenie.jpg);

    @include breakpoint('xs-down') {
        background-image: url(~@/assets/images/background-schizophrenie-mobile.jpg);
    }
}
.site-background__image--hilfsangebote {
    background-image: url(~@/assets/images/background-hilfsangebote.jpg);

    @include breakpoint('xs-down') {
        background-image: url(~@/assets/images/background-hilfsangebote-mobile.jpg);
    }
}

.fade-enter-active {
    transition: opacity 1000ms 250ms linear, transform 750ms 250ms;
}
.fade-leave-active {
    transition: opacity 500ms 250ms linear;
}
.fade-enter {
    opacity: 0;
    transform: scale(1.1);
}
.fade-leave-to {
    opacity: 0;
}
</style>
